// extracted by mini-css-extract-plugin
export var body = "_ks-0";
export var sectionHeader = "_ks-4";
export var shortcutColumns = "_ks-2";
export var shortcutList = "_ks-1";
export var shortcutSection = "_ks-3";